import type { StyleRule } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { gridClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    flexClassName,
    buttonClassName,
    pxArrayToRem,
} from '@archipro-design/aria';
import { MemberTileClassName, paragraphClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const MEMBER_TILE_HEIGHT = 658;
export const MEMBER_TILE_GRID_GAP = 90;
export const MEMBER_TILE_PREVIEW_HEIGHT = 50;

export const MASK_HEIGHT_VAR = '--loadMoreMaskHeight' as string;

export const TeamMemberGridMobile: StyleRule = () => ({
    display: 'grid',
    gridGap: pxArrayToRem([40, 6]),
    gridTemplateColumns: `repeat(2, ${pxToRem(186)})`,
    [`& .${MemberTileClassName} .${paragraphClassName}`]: {
        fontSize: pxToRem(16),
        lineHeight: 1,
        paddingBottom: pxToRem(1),
        marginTop: pxToRem(12),

        [`&:last-child`]: {
            marginTop: pxToRem(7),
        },
    },
});

export const TeamMemberGrid: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        gridGap: pxArrayToRem([MEMBER_TILE_GRID_GAP, 25]),

        [`& img`]: {
            height: 'inherit',
            width: 'inherit',
        },

        [`& .${MemberTileClassName} .${paragraphClassName}`]: {
            wordBreak: 'break-all',
        },
    },
});

export const TeamMemberLoadMore: StyleRule = () => ({
    paddingBottom: pxToRem(1),
    [`& .${svgIconClassName}`]: {
        marginTop: pxToRem(-8),
        marginRight: pxToRem(-10),
        width: pxToRem(42),
        height: pxToRem(42),
    },
    [`& div.${flexClassName}`]: {
        height: 'unset',
    },
});

export const MemberTileMobile: StyleRule = () => ({
    [`& .${captionClassName}`]: {
        marginTop: pxToRem(8),
    },
});

export const ViewAll: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(48),
    textAlign: 'center',
    [`& .${buttonClassName}`]: {
        display: 'flex',
        width: '100%',
        height: pxToRem(48),
        fontSize: 'inherit',
        border: `1px solid ${theme.siteVariables.colors.charcoal['000']}`,
        textDecoration: 'none',

        [`& .${labelClassName}`]: {
            fontSize: pxToRem(16),
            fontWeight: '500',
        },
        [`&:hover`]: {
            textDecoration: 'none',
            border: `1px solid ${theme.siteVariables.colors.charcoal['000']}`,
        },
    },
});

export const TeamMembersMobile: StyleRule = () => ({
    padding: pxArrayToRem([0, 18]),
});

export const TeamMembersSectionTitle: StyleRule = () => ({
    marginBottom: pxToRem(24),
});

export const TeamMembersSectionTitleMobile: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(30),
    ...theme.siteVariables.textStyles.Heading.Roman55,
    fontSize: theme.siteVariables.fontSizes.caption03,
    lineHeight: 1,
    letterSpacing: theme.siteVariables.letterSpacingSmall,
    textTransform: 'uppercase',
});

export const LoadMoreGrid: StyleRule = () => ({
    marginBottom: pxToRem(4),
});

export const TeamMemberWrapper: StyleRule = () => ({
    [`& > .${gridClassName}`]: {
        marginBottom: pxToRem(4),
    },
});

export const LoadMoreButton: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    marginTop: pxToRem(128),
    padding: pxArrayToRem([24, 42.5]),
    textTransform: 'uppercase',
    outline: `1px solid ${siteVariables.colorScheme.default?.foreground}`,
    [`& .${labelClassName}`]: {
        letterSpacing: siteVariables.letterSpacingMedium,
        fontWeight: 500,
    },
    [screen.tablet]: {
        marginLeft: pxToRem(924),
    },
});
